import { IonContent, IonPage, IonItem, IonInput, IonButton, IonImg, IonGrid, IonRow, IonCol, IonText, IonSpinner } from '@ionic/react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import SmartDocsLogo from '../assets/SmartDocsTextLogoLight.png';
import { authApi } from '../services/authApi';
import './SignIn.css';
import './AuthPages.css';

const ForgotPassword: React.FC = () => {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setIsLoading(true);

    try {
      await authApi.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      const apiError = err as { message?: string };
      setError(apiError.message || 'Failed to send password reset link. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <IonPage className="sign-in-page">
      <IonContent className="sign-in-content" fullscreen={false}>
        <div className="sign-in-wrapper">
          <IonGrid className="ion-text-center sign-in-grid">
            <IonRow className="ion-justify-content-center">
              <IonCol size="12" sizeMd="6" sizeLg="4">
                <div className="logo-container">
                  <IonImg src={SmartDocsLogo} alt="SmartDocs Logo" className="logo" />
                </div>

                <h2 className="auth-page-title">Forgot Password</h2>

                {success ? (
                  <div className="auth-message-container">
                    <IonText color="success" className="success-text">
                      Password reset link has been sent to your email.
                    </IonText>
                    <IonButton type="button" fill="clear" className="auth-link-button" onClick={() => history.push('/signin')}>
                      Back to Sign In
                    </IonButton>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="sign-in-form">
                    <IonItem className="custom-input no-border">
                      <IonInput
                        data-testid="forgot-password-email"
                        type="email"
                        value={email}
                        onIonInput={e => setEmail(e.detail.value || '')}
                        required
                        className="input-field no-autofill-border"
                        autocomplete="email"
                        label="Email"
                        labelPlacement="floating"
                        color="light"
                      />
                    </IonItem>

                    {error && (
                      <IonText color="danger" className="error-text">
                        {error}
                      </IonText>
                    )}

                    <IonButton
                      expand="block"
                      type="submit"
                      className="sign-in-button"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <div className="loading-container">
                          <IonSpinner name="crescent" />
                          <span className="loading-text">Sending reset link...</span>
                        </div>
                      ) : (
                        'Send Reset Link'
                      )}
                    </IonButton>

                    <IonButton type="button" fill="clear" className="auth-link-button" onClick={() => history.push('/signin')}>
                      Back to Sign In
                    </IonButton>
                  </form>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ForgotPassword;
